import { Loading, PopupWraper } from 'components';
import { Button, useForm } from 'modules';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { formSchema } from './config';

type Props = {
  isOpen: boolean;
  isLoading?: boolean;
  title: string;
  children: any;
  onClose: () => void;
  onSuccess: () => void;
  labelApprove?: string;
};

const ModalConfirmElement = (props: Props) => {
  const {
    isOpen,
    onSuccess,
    onClose,
    isLoading = false,
    title,
    children,
    labelApprove = 'Xác nhận',
  } = props;

  const [isShowPopup, setIsShowPopup] = useState<boolean>(isOpen);

  useEffect(() => {
    setIsShowPopup(isOpen);

    return () => setIsShowPopup(false);
  }, [isOpen]);

  const handleProgress = async (values: any) => {
    try {
      onSuccess();
    } catch (error: any) {
      console.error(error);
      toast.error(String(error?.message) || 'Xác thực không thành công');
    }
  };

  const { handleSubmit: handleSubmitModal, getInputProps: getInputPropsModal } =
    useForm({
      structure: formSchema,
      onSubmit: handleProgress,
    });

  if (!isShowPopup) return <></>;

  return (
    <PopupWraper
      center
      title={title}
      onClose={() => {
        setIsShowPopup(false);
        onClose();
      }}
    >
      <form onSubmit={handleSubmitModal} className='charge-bill-container'>
        <Loading isLoading={false}>
          <div className='charge-bill__title'>{children}</div>
          <div className='charge-bill__button-container'>
            <Button
              className='button__confirm mr5'
              label={labelApprove}
              buttonType='success'
              type='submit'
            />
            <Button
              className='button__cancel ml5'
              onClick={() => {
                setIsShowPopup(false);
                onClose();
              }}
              label='Trở về'
              buttonType='primary-outline'
            />
          </div>
        </Loading>
      </form>
    </PopupWraper>
  );
};

export default ModalConfirmElement;
